<header class="header__container">
    <div class="header">
        <div class="header__logo">
            <img [src]="logoUrl" alt="KioskPolis" class="header__logo--img">
        </div>

        <div class="header__text">
            <h2 class="header__title">
                {{ 'header' | translate }}
            </h2>
        </div>
    </div>
</header>

<div class="container container--center text-center">
    <div class="container__title container__title--with-image-under">
        <h2>{{ 'SESSION_ERROR_COMPONENT.header' | translate }}</h2>
    </div>
    <div class="container__content">
        <img *ngIf="imageUrl" [src]="imageUrl" alt="">
        <p class="big-text">{{ 'SESSION_ERROR_COMPONENT.sessionExpiredMessage' | translate }}</p>
        <p class="big-text">{{ 'SESSION_ERROR_COMPONENT.continueMessage' | translate }}</p>
    </div>
    <div class="button__container">
        <button class="btn btn--secondary btn--big btn--no-outline"
                [ngClass]="{'btn--anchor': anchorButton}"
                id="prev-desktop-button"
                (click)="refreshApp()">
            <ng-container *ngIf="!anchorButton; else anchorBtn">
                {{ 'SESSION_ERROR_COMPONENT.action' | translate }}
            </ng-container>
            <ng-template #anchorBtn>
                <a [href]="redirectUrl | safeUrl" target="_blank">
                    {{ 'SESSION_ERROR_COMPONENT.action' | translate }}
                </a>
            </ng-template>
        </button>
    </div>
</div>
